import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TenderListPage from './pages/TenderListPage';
import ArchivedTendersPage from "./pages/ArchivedTendersPage";
import TenderDetailPage from "./pages/TenderDetailPage";
import TaskPage from './pages/TaskPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { getCurrentUser } from './services/auth';
import { UserProvider, useUser } from './context/UserContext';

function AppContent() {
  const { user, setUser, isLoading } = useUser();

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token && !user) {
      getCurrentUser()
        .then(userData => setUser(userData))
        .catch(() => {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
        });
    }
    // eslint-disable-next-line
  }, [user, setUser]);
  if (isLoading){
    return <div>Загрузка...</div>;
  }
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={user ? <TenderListPage /> : <HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/tenders"
          element={
            <ProtectedRoute>
              <TenderListPage />
            </ProtectedRoute>
          }
        />
         <Route
          path="/tenders/:id"
          element={
           <ProtectedRoute>
             <TenderDetailPage />
            </ProtectedRoute>
         }
         />
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/tenders/archive" element={<ArchivedTendersPage />} />
      </Routes>
    </Router>
  );
}

export default function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}
